@for (order of orders; track order) {
  <div class="mobile-cards" (click)="navigationService.goToOrderDetailsPage(order.id)">
    <ion-row>
      <ion-col size="6">
        <div class="left-container">
          <p class="date" style="font-size: 10px">
            <span class="label">Created</span>
            @if (tryParseDate(order.createdAt); as d) { {{ d | date: "mediumDate" }} } @else { - }
          </p>
          <p class="name" innerHTML="{{ order.customerFullName | highlightsearch: searchString }}"></p>
        </div>
      </ion-col>
      <ion-col size="6">
        <div class="right-container">
          <rc-service-type-badge [serviceType]="order.serviceType"></rc-service-type-badge>
          <p class="date" style="font-size: 16px">
            {{ order.earliestFulfillment | date: "MMM d" }}
          </p>
        </div>
      </ion-col>
    </ion-row>
  </div>
}

@if (orders.length === 0) {
  <p style="text-align: center">No Results.</p>
}
